import { type DefaultQueryError, httpClient } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { DefaultOpsTechResponse } from '../types';
import type { MyReward } from './types';
import apiRoutes from '@/lib/api-routes';

export type markRewardInput = {
  id: number;
  status: string;
};

export const markRewardFn = async (input: markRewardInput) => {
  const response = await httpClient.put<DefaultOpsTechResponse<MyReward>>(
    apiRoutes.rewards.markReward(input.id),
    {
      status: input.status,
    }
  );
  return response.data;
};

export const useMarkReward = (
  opts?: UseMutationOptions<
    DefaultOpsTechResponse<MyReward>,
    DefaultQueryError,
    markRewardInput
  >
) =>
  useMutation<
    DefaultOpsTechResponse<MyReward>,
    DefaultQueryError,
    markRewardInput
  >({
    mutationKey: [apiRoutes.rewards.markReward],
    mutationFn: markRewardFn,
    ...opts,
  });
